// extracted by mini-css-extract-plugin
module.exports = {"widthItems":"StudentPerformanceFilter_widthItems_1kKVY"};